module.exports = __webpack_public_path__ + "shared/static_img/send.ab240720.svg";